import * as React from 'react';
import clsx from 'clsx';

export interface ISwitcherItem {
    code: string | number;
    label: string;
}

/* eslint-disable @typescript-eslint/indent */
type PickDivProps = Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'onClick'
>;
/* eslint-enable @typescript-eslint/indent */


export interface ISwitcherItemProps extends PickDivProps {
    item: ISwitcherItem;
    active: boolean;
    onClick: (item: ISwitcherItem) => void;
}

export const SwitcherItem = React.forwardRef<HTMLDivElement, ISwitcherItemProps>(({
    item,
    onClick,
    className,
    active,
    ...restDivProps
}, ref) => (
    <div
        onClick={() => {
            onClick(item);
        }}
        className={clsx('track-item', className, {
            active: active
        })}
        ref={ref}
        {...restDivProps}
    >
        <div className="item-name">
            {item.label}
        </div>
    </div>
));
